import React from 'react';
import './order-details.css';
import formatDate from '../../formatters/date.js';
import deletedItemImage from './deleted-item.png';

const renderItem = (item) => (
  <li key={item.id} className="OrderDetails__item">
    <a className="OrderDetails__item__link block" href={item.url} target="_blank">
      <img className="OrderDetails__item__image" src={item.image || deletedItemImage} alt={item.title}/>
      <p className="OrderDetails__item__title">{item.title}</p>
    </a>
  </li>
)

export default ({order}) => (
  <section className="OrderDetails">
    <header className="OrderDetails__header">
      <h2>
        Purchased on <span
          className="OrderDetails__bought-at"
        >{formatDate(order.bought_at)}</span> from
      </h2>
      {order.url &&
        <a className="OrderDetails__order__link" href={order.url} target="_blank">
          View order &rarr;
        </a>
      }
    </header>
    <div className="OrderDetails__shop">
      <div>
        <a className="OrderDetails__shop__link block" href={order.shop.url} target="_blank">
          <img className="OrderDetails__shop__image" src={order.shop.image} alt={order.shop.title}/>
          <p className="OrderDetails__shop__title">{order.shop.title}</p>
        </a>
      </div>
    </div>
    <ul className="OrderDetails__items">
      {order.items.map(i => renderItem(i))}
    </ul>
  </section>
);



// WEBPACK FOOTER //
// ./src/app/reviews/order-details.js